<div class="sign"  [style.width.px]="width" [style.height.px]="height"></div> 
 